import { render, staticRenderFns } from "./AgregaCovid.vue?vue&type=template&id=3a992cdc&"
import script from "./AgregaCovid.vue?vue&type=script&lang=js&"
export * from "./AgregaCovid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports